"use client"

import { useEffect, useRef, useState } from "react"
import "./Contacto_info.modules.css"

// Componentes de iconos simples
const MailIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
)

const PhoneIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
)

const MapPinIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
)

const ClockIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12,6 12,12 16,14" />
  </svg>
)

// Icono de WhatsApp
const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
  </svg>
)

const SendIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22,2 15,22 11,13 2,9 22,2" />
  </svg>
)

// Nuevos iconos de redes sociales
const InstagramIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
)

const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
)

const XIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
  </svg>
)

export default function ContactInfo() {
  const [isVisible, setIsVisible] = useState(false)
  const [activeCard, setActiveCard] = useState(null)
  const containerRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      },
    )

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => observer.disconnect()
  }, [])

  const contactInfo = [
    {
      icon: MailIcon,
      title: "Email",
      value: "gerencia.juridica@defensafinanciera.com.co",
      description: "Respuesta en 24 horas",
      colorClass: "blue-icon",
      action: "mailto:gerencia.juridica@defensafinanciera.com.co",
    },
    {
      icon: PhoneIcon,
      title: "Teléfono",
      value: "+57 (310) 264 6177 ",
      description: "Lun - Vie, 9:00 - 18:00",
      colorClass: "green-icon",
      action: "tel:+573102646177 ",
    },
    {
      icon: MapPinIcon,
      title: "Ubicación",
      value: "Manizales Caldas, Colombia",
      description: "Carrera 23 # 62-39 Edificio Capitalia oficina 602a, Manizales.",
      colorClass: "red-icon",
      action: "https://maps.google.com",
    },
  ]

  const socialLinks = [
    { icon: InstagramIcon, href: "#", label: "Instagram" },
    { icon: FacebookIcon, href: "#", label: "Facebook" },
    { icon: XIcon, href: "#", label: "X" },
  ]

  const handleCardClick = (action) => {
    window.open(action, "_blank")
  }

  // Función para abrir WhatsApp
  const handleWhatsAppClick = () => {
    const phoneNumber = "573175789585" // Número sin espacios ni caracteres especiales
    const message = encodeURIComponent("Hola, ¿cómo podemos colaborarte?")
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`
    window.open(whatsappURL, "_blank")
  }

  return (
    <div ref={containerRef} className="contact-container">
      <div className="contact-max-width">
        {/* Header Section */}
        <div className={`contact-header ${isVisible ? "visible" : ""}`}>
          <span className="contact-badge">Contacto</span>
          <h1 className="contact-title">Hablemos</h1>
          <p className="contact-subtitle">
            Estamos aquí para ayudarte. Ponte en contacto con nosotros a través de cualquiera de estos canales.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className="contact-cards-grid">
          {contactInfo.map((item, index) => {
            const IconComponent = item.icon
            return (
              <div
                key={index}
                className={`contact-card ${isVisible ? "card-visible" : ""} ${
                  activeCard === index ? "card-active" : ""
                }`}
                style={{
                  transitionDelay: `${index * 150}ms`,
                  animationDelay: `${index * 150}ms`,
                }}
                onMouseEnter={() => setActiveCard(index)}
                onMouseLeave={() => setActiveCard(null)}
                onClick={() => handleCardClick(item.action)}
              >
                <div className={`contact-icon-container ${item.colorClass}`}>
                  <IconComponent />
                </div>
                <h3 className="contact-card-title">{item.title}</h3>
                <p className="contact-card-value">{item.value}</p>
                <p className="contact-card-description">{item.description}</p>
                <div className="contact-card-indicator" />
              </div>
            )
          })}
        </div>

        {/* Action Button - Modificado para WhatsApp */}
        <div className={`contact-action-section ${isVisible ? "visible" : ""}`}>
          <button className="contact-action-button" onClick={handleWhatsAppClick}>
            <WhatsAppIcon />
            Enviar Mensaje por WhatsApp
          </button>
        </div>

        {/* Social Links */}
        <div className={`contact-social-section ${isVisible ? "visible" : ""}`}>
          <p className="contact-social-text">Síguenos en redes sociales</p>
          <div className="contact-social-links">
            {socialLinks.map((social, index) => {
              const IconComponent = social.icon
              return (
                <a key={index} href={social.href} className="contact-social-link" aria-label={social.label}>
                  <IconComponent />
                </a>
              )
            })}
          </div>
        </div>

        {/* Business Hours Card */}
        <div className={`contact-hours-card ${isVisible ? "visible" : ""}`}>
          <ClockIcon />
          <h3 className="contact-hours-title">Horarios de Atención</h3>
          <div className="contact-hours-grid">
            <div className="contact-hours-item">
              <p className="contact-hours-day">Lunes - Viernes</p>
              <p className="contact-hours-time">8:00 AM - 6:00 PM</p>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  )
}